import {
  Accordion,
  Box,
  Group,
  Skeleton,
  Text,
  useMantineTheme,
  useMantineColorScheme,
  Popover,
  Tooltip,
  ThemeIcon,
} from "@mantine/core";
import { useCallback, useRef, useState } from "react";
import { areEqual, FixedSizeList as ListWindow } from "react-window";
import ReactVirtualizedAutoSizer from "react-virtualized-auto-sizer";
import { memo } from "react";
import { CaptureThumb, FilterButton } from "core/components/index";
import InfiniteLoader from "react-window-infinite-loader";
import { logger } from "utils/logger";
import classes from "./BottomTray.module.scss";
import CaptureFilterPanel from "../capture/CaptureFilterPanel";
import { IconNote } from "@tabler/icons-react";

const BottomTray = ({
  captures,
  onImageEvent,
  thumbnailSize = 122,
  selectedItems = [],
  comparisonItems = [],
  selectedComparisonFrame,
  showComapirsonSelection = false,
  imageLocHash,
  showLoading = false,
  onCaptureChange,
  searchCursor,
  isSearching,
  loadNextPage,
  showSettings = false,
  mediaFilter,
  setMediaFilter,
  bottomTrayOpen,
  onBottomTrayOpenChange,
}) => {
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const listContainerRef = useRef(null);
  const infiniteLoaderRef = useRef(null);
  const [scrollState, setScrollState] = useState({
    rowCount: 0,
    colCount: 0,
    scrolledColumn: 0,
  });
  // const [listWidth,setListWidth] = useState(400);

  const isSelected = (val) => {
    return selectedItems.find((item) => val.id === item.id) ? true : false;
  };

  const ProxyCol = memo((props) => {
    const { index, style } = props;
    // const idx = columnIndex + ((rowIndex) * data.colCount);

    const ThumbCallback = useCallback(({ index, style }) => {
      return (
        <div style={{ height: "100%", width: 150, padding: 5 }}>
          <Box style={{ width: "100%", height: "100%" }}>
            <Skeleton width={"100%"} height={"60%"} />
            <Skeleton height={8} mt={10} radius="xl" />
            <Skeleton height={8} mt={5} width="70%" radius="xl" />
          </Box>
        </div>
      );
    }, []);

    // if(!captures[idx]){
    //     return (<div></div>);
    // }

    const tmpStyle = { ...style };
    return (
      <div key={`${index}`} style={tmpStyle}>
        <ThumbCallback {...props} />
      </div>
    );
  }, areEqual);

  const Column = ({ index, style }) => {
    const val = captures[index];
    const obj = comparisonItems.find((capture) => capture.id === val.id);
    const captureIdx = comparisonItems.indexOf(obj);

    var cls = obj ? "capture-selected capture-wrapper" : "capture-wrapper";
    if (captureIdx === 0) {
      cls += " capture-primary";
    } else if (captureIdx === 1) {
      cls += " capture-secondary";
    }

    if (!showComapirsonSelection) {
      cls = "";
    }

    var imageURL = val.previewLo;
    let imageRefKey = thumbnailSize > 200 ? "previewMid" : "previewLo";
    if (
      val &&
      imageLocHash.current[val.id] &&
      val[imageRefKey] === imageLocHash.current[val.id]
    ) {
      imageURL = imageLocHash.current[val.id];
    } else {
      //getImage();
      imageLocHash.current[val.id] =
        thumbnailSize > 200 ? val.previewMid : val.previewLo;
      imageURL = imageLocHash.current[val.id];
    }

    return (
      <Box
        px={2}
        key={index}
        style={{
          width: 150,
          height: "100%",
          textAlign: "center",
          position: "relative",
          ...style,
        }}
        spacing="xs"
        className={cls}
      >
        
        <CaptureThumb
          image={val}
          showSettings={showSettings}
          src={imageURL}
          onImageEvent={onImageEvent}
          size={thumbnailSize}
          selected={isSelected(val)}
          onCaptureChange={onCaptureChange}
          radius={theme.radius.md}
          badgeLabel={obj && showComapirsonSelection ? captureIdx + 1 : null}
          showZoom={false}
          showNoteIndicator={true}
        />
      </Box>
    );
  };

  // useEffect(() => {
  //     if(listContainerRef && listContainerRef.current){
  //         logger.log(listContainerRef.current)
  //         let w  = listContainerRef && listContainerRef.current?listContainerRef.current.offsetWidth-30:400;
  //          if(listWidth !== w)
  //              setListWidth(w);
  //     }
  // })
  const [filterOpen, setFilterOpen] = useState(false);
  const filterButtonHandler = () => {
    setFilterOpen(true);
  };
  const onClearClick = () => {
    setFilterOpen(false);
  };

  const getFilterCount = (val) => {
    var count = 0;   

    return count;
  };
  const getFilterItems = (val) => {
    return [];
  };
  const filterCount = getFilterCount(mediaFilter);
  const filterItems = getFilterItems([]);
  const setFilterVars = (vals) => {
    setMediaFilter(vals);
  };


  

  return (
    <div
      ref={listContainerRef}
      style={{ position: "relative" }}
      className={`${classes.container} unhightable`}
    >
      <Accordion defaultValue="images"  value={bottomTrayOpen? "images" : null}  onChange={onBottomTrayOpenChange} >
        <Accordion.Item value="images">
          <Accordion.Control>
            <Group justify="space-between" 
            onClick={(e) => {
            // logger.log(value, e);
            // if the target is not a group, don't set the value
            if(!e.target.classList.contains("mantine-Group-root")){
              return;
            }
            //   setValue(value === "images" ? null : "images");
              onBottomTrayOpenChange(bottomTrayOpen ? null : "images");
            }}
            
            >
              <Group>
                Images{" "}
                <Text c={"dimmed"} size="sm">
                  Displaying {captures?.length} Images
                </Text>
              </Group>
              {/* add popover to show capture filter */}
              {/* <Group>
                <Popover
                  shadow="sm"
                  opened={filterOpen}
                  popoverProps={{
                    onClick: (e) => {
                      e.stopPropagation();
                      e.nativeEvent.stopPropagation();
                    }
                  }}
                  onChange={setFilterOpen}
                  width={500}
                  withArrow
                  closeOnClickOutside={true}
                  closeOnEscape={true}
                  trapFocus={false}
                  position="bottom-end"
                  clickOutsideEvents={["mousedown", "touchstart"]}

                  // onClose={() => setFilterOpen(false)}
                >
                  <Popover.Target>
                    <div>
                      <FilterButton
                        onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopPropagation();
                            filterButtonHandler(e);
                        }}
                        onClear={onClearClick}
                        count={filterCount}
                      />
                    </div>
                  </Popover.Target>
                  <Popover.Dropdown>
                    <div style={{ display: "flex" }}>
                      <CaptureFilterPanel
                        filter={mediaFilter}
                        onCancel={() => setFilterOpen(false)}
                        onApply={(vals) => {
                          setFilterVars(vals);
                          setFilterOpen(false);
                        }}
                        filterItems={filterItems}
                        styleCodes={[]}
                        departments={[]}
                      />
                    </div>
                  </Popover.Dropdown>
                </Popover>
              </Group> */}
            </Group>
          </Accordion.Control>
          <Accordion.Panel>
            <div style={{ height: showSettings ? 230 : 180 }}>
              <ReactVirtualizedAutoSizer>
                {({ height, width }) => {
                  const colWidth = 200;

                  var colCount = showLoading ? 4 : captures.length;
                  var rowCount = 1;
                  // Only load 1 page of items at a time.
                  // Pass an empty callback to InfiniteLoader in case it asks us to load more than once.
                  const loadMoreItems = (startIndex, endIndex) => {
                    if (!isSearching && searchCursor) {
                      loadNextPage();
                      logger.log("should grab more items");
                    }
                  };

                  // Every row is loaded except for our loading indicator row.
                  // const isItemLoaded = (index) => !searchCursor || index < rowCount;
                  const isColLoaded = (index) => {
                    return index < colCount - 1;
                  };

                  return (
                    <>
                      {showLoading ? (
                        <ListWindow
                          height={height}
                          itemCount={5}
                          itemSize={150}
                          layout="horizontal"
                          width={width}
                        >
                          {ProxyCol}
                        </ListWindow>
                      ) : (
                        <InfiniteLoader
                          ref={infiniteLoaderRef}
                          isItemLoaded={isColLoaded}
                          itemCount={scrollState.colCount}
                          loadMoreItems={loadMoreItems}
                        >
                          {({ onItemsRendered, ref }) => {
                            return (
                              <ListWindow
                                height={height}
                                itemCount={captures.length}
                                itemSize={184}
                                layout="horizontal"
                                width={width}
                                onItemsRendered={(e) => {
                                  const {
                                    visibleStartIndex,
                                    visibleStopIndex,
                                    overscanStopIndex,
                                    overscanStartIndex,
                                  } = e;
                                  logger.log("on items rendered");
                                  if (
                                    scrollState.colCount !== colCount ||
                                    scrollState.rowCount !== rowCount
                                  ) {
                                    setScrollState({
                                      rowCount,
                                      colCount,
                                      scrolledColumn: visibleStartIndex,
                                    });
                                  }
                                  // props.setScrollRowAndColumn(visibleRowStartIndex, visibleColumnStartIndex)
                                  onItemsRendered({
                                    overscanStartIndex: overscanStartIndex,
                                    overscanStopIndex: overscanStopIndex,
                                    visibleStartIndex: visibleStartIndex,
                                    visibleStopIndex: visibleStopIndex,
                                  });
                                }}
                                ref={ref}
                              >
                                {Column}
                              </ListWindow>
                            );
                          }}
                        </InfiniteLoader>
                      )}
                    </>
                  );
                }}
              </ReactVirtualizedAutoSizer>
            </div>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default BottomTray;
